export const bannerInfo = '/clientservicing/api/banner'
export const sessionTimeoutLog = '/clientservicing/api/sessionTimeoutLogs'
export const sessionTimeoutCleanup = '/clientservicing/api/sessionTimeoutCleanup'
export const routesRegistration = {
    activateFactor: '/clientservicing/api/registration/activateFactor',
    enrollFactor: '/clientservicing/api/registration/enrollFactor',
    enrollMFA: '/clientservicing/api/registration/enrollMFA',
    getAccountRecovery: '/clientservicing/api/registration/getAccountRecovery',
    getAuthenticators: '/clientservicing/api/registration/getAuthenticators',
    getLogins: '/clientservicing/api/registration/getLogins',
    registration: '/clientservicing/api/registration',
    sendChallenge: '/clientservicing/api/registration/sendChallenge',
    setPassword: '/clientservicing/api/registration/setPassword',
    setupRecoveryPhone: '/clientservicing/api/registration/setupRecoveryPhone',
    verifyAccountRecovery: '/clientservicing/api/registration/verifyAccountRecovery',
}

export const routesForgotpwd = {
    getAccountRecovery: '/clientservicing/api/forgotpwd/getAccountRecovery',
    getLogins: '/clientservicing/api/forgotpwd/getLogins',
    resetPassword: '/clientservicing/api/forgotpwd/resetPassword',
    sendChallenge: '/clientservicing/api/forgotpwd/sendChallenge',
    verifyAccountRecovery: '/clientservicing/api/forgotpwd/verifyAccountRecovery',
    verifyRecoveryToken: '/clientservicing/api/verifyRecoveryToken'
}

export const routesLogin = {
    activateFactor: '/clientservicing/api/login/activateFactor',
    authenticate: '/clientservicing/api/authenticate',
    clearOktaUserSession: '/clientservicing/api/logout',
    enrollAuthFactor: '/clientservicing/api/login/enrollAuthFactor',
    enrollMFA: '/clientservicing/api/login/enrollMFA',
    forgotPassword: '/clientservicing/api/forgotPassword',
    getAccountRecovery: '/clientservicing/api/login/getAccountRecovery',
    getAuthenticators: '/clientservicing/api/login/getAuthenticators',
    init: '/clientservicing/api/init',
    loginApp: '/clientservicing/api/login/loginApp',
    passwordLessLogin: '/clientservicing/api/sendMagicLink',
    passwordLessVerification: '/clientservicing/api/verifyPasswordLessToken',
    preActivateAlternateAccountRecovery: '/clientservicing/api/login/preactivateAlternateAccountRecovery',
    sendChallenge: '/clientservicing/api/login/sendChallenge',
    skipEnrollment: '/clientservicing/api/login/skipEnrollment',
    verifyAccountRecovery: '/clientservicing/api/login/verifyAccountRecovery',
    verifyFactor: '/clientservicing/api/login/verifyFactor',
}

export const routesAnalyticsRegister = {
    requestPhoneCodes: '/clientservicing/api/getPhoneCodes',
    requestRecaptcha: '/clientservicing/api/getRecaptchaValues',
    submitRequest: '/clientservicing/api/quickRegister'
}

export const routesDefaultRegister = {
    requestApplication: '/clientservicing/api/requestAccessApplications',
    requestPhoneCodes: '/clientservicing/api/getPhoneCodes',
    requestRecaptcha: '/clientservicing/api/getRecaptchaValues',
    submitRequest: '/clientservicing/api/defaultRegister'
}
